import {RemoteClient, Client} from 'common/src/modules/clients/clients.types';
import Subject from 'common/src/utils/pubsub/subject';
import {CLPromiseRef} from '../shared.types';

const clientPromise: CLPromiseRef<RemoteClient> = {current: null};

const clientSubject = new Subject<Client>(null);

export {clientPromise, clientSubject};
